<template>
    <div>
        <div v-if="abnormal" class="container">
            <img class="logo" src="@/assets/images/user/talk/logo.png" alt="">
            <img class="right" src="@/assets/images/user/talk/right.png" alt="">
            <img class="left" src="@/assets/images/user/talk/left.png" alt="">
            <div class="center">
                <div class="title">
                    AI-LiNK体验邀请函
                </div>
                <div class="content">
                    <div class="top">尊敬的
                        <div>{{ReportUserInfoData.uname}}</div>
                        <div v-if="$route.query.usertype == 0">先生/女士</div>
                    </div>
                    <p>您好！</p>
                    <p>特邀您前往A.O.史密斯AI-LiNK城市体验中心，对AI-LiNK冷暖风水专业集成系统的设计、施工及使用效果进行体验，期待您的光临！</p>
                </div>
                <template v-if="!other">
                    <!-- 显示接受邀请或者是显示已接受邀请 -->
                    <div class="accept" v-if="!Baccept" @click='accept'>
                        <img class="acceptimg" src="@/assets/images/user/talk/accept.png" alt="">
                    </div>
                    <div class="accept" v-else @click='toast'>
                        <img class="acceptimg" src="@/assets/images/user/talk/acceptok.png" alt="">
                    </div>
                </template>
            </div>
            <div class="address">
                <div class="addr">
                    <p>
                        <span class="address-title">体验地址</span>
                        <span class="address-name">{{ReportUserInfoData.experience_name}}</span>
                    </p>
                    <p class="address-addr">详细地址：{{ReportUserInfoData.experience_address}}</p>
                </div>
                <div class="navigation" @click="navigation">
                    <img src="@/assets/images/user/talk/navigation.png" alt="">
                </div>
            </div>
            <div class="time">
                <div>体验时间</div>
                <div>{{ReportUserInfoData.mark_start}}</div>
            </div>
            <div class="userinfo">
                <div>
                    <span class="user-name-title">邀约人:</span>
                    <span class="user-name">{{ReportUserInfoData.sign_name}}</span>
                    <span>联系方式:</span>
                    <span>
                        <a :href="'tel:'+ReportUserInfoData.sign_phone">{{ReportUserInfoData.sign_phone}}</a>
                    </span>
                </div>

            </div>
            <div class="bottom" v-if="!other">
                <div class="xieyi">
                    <span @click="clickAgree" class="checkbox">
                        <span v-if="agree" class="check"></span>
                    </span>
                    <span @click="readAgree">请确认A.O.史密斯用户隐私授权条款</span>
                </div>
                <div class="cancel">
                    <span v-if="Bcancel" @click="cancelClick">取消预约</span>
                </div>
            </div>
        </div>
        <div v-else class="nodata">
            <Member></Member>
        </div>
        <el-authority @changeLogin="changeLogin"></el-authority>

        <infoToast @acceptOk="acceptOk" :BinfoToast.sync="BinfoToast"></infoToast>
    </div>
</template>
<script>
import { Dialog } from 'vant'
import { getWxSingleConfig } from '@/js/wx.js';
import Member from '../../../member/common/business.vue'
import infoToast from './components/infotoast.vue'
import elAuthority from "@/components/hvac/authority/index.vue"
export default {
    name: 'invitationImg',
    components: {
        Member,
        infoToast,
        elAuthority
    },
    data() {
        return {
            agree: true,
            Baccept: false,//是否已接受邀请
            Bcancel: true,//是否显示取消按钮
            other: false,
            abnormal: true,    // 邀请不存在
            BinfoToast: false,// 填写电话号码，用户姓名
        }
    },
    created() {
        let that = this;
        $init(() => {
            console.log(this.$store.state.bAutorty, 'bAutorty');
            this.$store.commit("loadSwitch", true)
            const report_id = that.$route.query.report_id
            getWxSingleConfig({ share_link: window.location.href + '&type=invite' })
            if (that.$route.query.type == 'invite') {
                that.other = true
                that.$store.dispatch({ type: 'userTalkAppointV2/getCReportInfoData', report_id: report_id }).then((res) => {
                    console.log(that.ReportUserInfoData.state.is_mine, that.$route.query.usertype, '5555555');
                    if ((that.ReportUserInfoData.state == 3 || that.ReportUserInfoData.state > 3) && that.$route.query.usertype == 0) {
                        that.Baccept = true
                    } else if (that.$route.query.usertype == 1 && that.ReportUserInfoData.is_mine == 1) {
                        that.Baccept = true
                    } else {
                        this.Bcancel = false
                    }
                    if (that.$route.query.usertype == 0) {
                        this.Bcancel = true
                    }
                })
            } else {
                that.$store.commit("loadSwitch", false)
                that.$store.dispatch({ type: 'userTalkAppointV2/getCReportInfoData', report_id: report_id }).then((res1) => {
                    console.log(that.ReportUserInfoData.is_mine, that.$route.query.usertype, '666666666');
                    if ((that.ReportUserInfoData.state == 3 || that.ReportUserInfoData.state > 3) && that.$route.query.usertype == 0) {
                        that.Baccept = true
                    } else if (that.$route.query.usertype == 1 && that.ReportUserInfoData.is_mine == 1) {
                        that.Baccept = true
                    } else {
                        this.Bcancel = false
                    }

                    if (that.$route.query.usertype == 0) {
                        this.Bcancel = true
                    }
                })
            }
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name == 'agree') {
                vm.agree = true
            }
        });
    },
    methods: {
        changeLogin(res) {
            let phone = res.data.data.result.phone
            this.$store.dispatch({type: 'userTalkAppointV2/getAgreementData', code: 'discuss_rule'})
            this.$store.dispatch({type: 'userTalkAppointV2/SendDiscussAccept', report_id: this.ReportUserInfoData.id}).then(() => {
                this.Baccept = true;
                this.Bcancel = false
            })
        },
        toast() {
            this.$toast({ message: "您已接受邀请" })
        },
        clickAgree() {
            this.agree = !this.agree
        },
        cancelClick() {
            console.log(1111);
            // usertype 0 潜客 1其他3种类型
            let usertype = this.$route.query.usertype
            if (usertype == 0) {
                this.$store.dispatch({ type: 'userTalkAppointV2/SendcancelAppoint', report_id: this.$route.query.report_id }).then(() => {
                    this.$toast({ message: '取消成功' })
                    this.Baccept = false
                    this.Bcancel = false
                })
            } else {
                this.$store.dispatch({ type: 'userTalkAppointV2/SendReportCancel2', report_id: this.$route.query.report_id }).then(() => {
                    this.$toast({ message: '取消成功' })
                    this.Baccept = false
                    this.Bcancel = false
                })
            }
        },
        // 导航
        navigation() {
            const experience_lon = this.ReportUserInfoData.experience_lon
            const experience_lat = this.ReportUserInfoData.experience_lat
            console.log(this.ReportUserInfoData, 're');
            wx.openLocation({
                latitude: Number(experience_lat), // 纬度，浮点数，范围为90 ~ -90
                longitude: Number(experience_lon), // 经度，浮点数，范围为180 ~ -180。
                name: this.ReportUserInfoData.experience_name, // 位置名
                address: this.ReportUserInfoData.experience_address, // 地址详情说明
                scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
            });
        },
        accept() {
            let that = this
            let type = this.$route.query.usertype
            // type 是0 说明是潜客的邀请函，如果是1则是其他3种类型的邀请函
            if (type == 1) {
                this.BinfoToast = true
                return
            }
            // 判断用户是否阅读了条款，
            if (this.agree) {
                // 鉴权
                that.$oInitData.memberInfo({h5_user_id: that.$storage.getStorage('user_id')}).then((res) => {
                    this.$store.dispatch({type: 'userTalkAppointV2/getAgreementData', code: 'discuss_rule'})
                    this.$store.dispatch({type: 'userTalkAppointV2/SendDiscussAccept', report_id: this.ReportUserInfoData.id}).then(() => {
                        this.Baccept = true;
                        this.Bcancel = false
                    })
                    that.$userHouse.commit("setUser", res.result);
                }).catch(error => {
                    this.abnormal = false;
                });
            } else {
                this.$toast({message: "请阅读条款"})
            }

        },
        // 类型不是潜客的用户点击接受邀请
        acceptOk(options) {
            let that = this
            // that.$oInitData.memberInfo({h5_user_id: that.$storage.getStorage('user_id')}).then((res) => {
            this.$store.dispatch({ type: 'userTalkAppointV2/getAgreementData', code: 'discuss_rule' })
            this.$store.dispatch({ type: 'userTalkAppointV2/SendDiscussAccept2', report_id: this.ReportUserInfoData.id, ...options }).then(() => {
                this.Baccept = true;
                this.Bcancel = true
            })
            // that.$userHouse.commit("setUser", res.result);
            // }).catch(error => {
            //     this.abnormal = false;
            // });
        },
        readAgree() {
            this.agree = true
            this.$store.dispatch({ type: 'userTalkAppointV2/getAgreementData', code: 'discuss_rule' })
            this.$router.push('/user/inviation/agree')
        }
    },
    computed: {
        ReportUserInfoData() {
            return this.$store.state.userTalkAppointV2.ReportUserInfoData
        },
    }
}
</script>
<style lang='scss' scoped>
.container {
  width: 100vw;
  height: 100vh;
  background-image: url("~@/assets/images/user/talk/invitationbg.png");
  background-size: cover;
  position: relative;
  padding-top: 167px;
  user-select: none;
  .logo {
    width: 236px;
    height: 28px;
    position: absolute;
    left: 62px;
    top: 86px;
  }

  .left {
    z-index: 999;
    width: 122px;
    height: 173px;
    position: absolute;
    top: 480px;
    left: 1px;
  }

  .center {
    width: 612px;
    height: 705px;
    margin: 0 auto;
    background-image: url("~@/assets/images/user/talk/center.png");
    background-size: cover;
    position: relative;

    .title {
      font-size: 38px;
      font-weight: 500;
      color: #986f34;
      padding-top: 64px;
      text-align: center;
    }

    .content {
      padding: 51px 104px 0 92px;
      font-size: 24px;
      font-weight: 400;
      color: #000000;
      line-height: 35px;

      p {
        margin-bottom: 5px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
      .top {
        margin-bottom: 5px;
        display: flex;
        white-space: nowrap;
        div:nth-child(1) {
          text-align: center;
          display: inline-block;
          min-width: 147px;
          height: 35px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border-bottom: solid 1px #000000;
        }
      }
    }

    .accept {
      width: 295px;
      height: 76px;
      position: absolute;
      left: 158px;
      bottom: 51px;

      .acceptimg {
        width: 295px;
        height: 74px;
      }
    }
  }

  .address {
    display: flex;
    padding: 83px 91px 0 91px;

    .addr {
      flex: 1;

      p {
        margin-bottom: 10px;
      }

      .address-title {
        display: inline-block;
        text-align: center;
        width: 119px;
        border-left: #e5cea4 1px solid;
        border-right: #e5cea4 1px solid;
        font-size: 24px;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #e5cea4;
      }

      .address-name {
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 10px;
      }

      .address-addr {
        font-size: 20px;
        font-weight: 300;
        color: #ffffff;
        line-height: 28px;
        width: 456px;
      }
    }

    .navigation {
      width: 71px;
      height: 62px;

      img {
        width: 71px;
        height: 62px;
      }
    }
  }

  .time {
    margin-top: 120px;
    text-align: center;

    div {
      display: inline-block;
    }

    div:first-child {
      width: 119px;
      font-size: 24px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #e5cea4;
      border-left: solid 1px #e5cea4;
      border-right: solid 1px #e5cea4;
    }

    div:last-child {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      margin-left: 13px;
    }
  }

  .userinfo {
    margin-top: 15px;
    display: flex;
    justify-content: center;

    div {
      height: 50px;
      display: flex;
      padding: 12px 0;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      border-top: solid 1px #ffffff;
      border-bottom: solid 1px #ffffff;

      a {
        color: #ffffff;
        text-decoration: none;
      }

      span:nth-child(1) {
        font-size: 21px;
        font-weight: 400;
        color: #ebdbb6;
      }

      span:nth-child(2) {
        margin-left: 15px;
        font-size: 21px;
        font-weight: 400;
        color: #ffffff;
      }

      span:nth-child(3) {
        margin-left: 20px;
        font-size: 21px;
        font-weight: 400;
        color: #ebdbb6;
      }

      span:nth-child(4) {
        font-size: 21px;
        margin-left: 15px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .bottom {
    margin-top: 53px;
    text-align: center;
    line-height: 50px;

    .xieyi {
      font-size: 20px;
      font-family: SourceHanSansCN;
      font-weight: 300;
      color: #ffffff;
      line-height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      span:last-child {
        text-decoration: underline;
      }

      .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: solid #ffffff 1px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;

        .check {
          width: 12px;
          border-radius: 50%;
          height: 12px;
          background-color: #ffffff;
        }
      }
    }

    .cancel {
      text-align: right;
      padding-right: 80px;
      font-size: 18px;
      color: #ffffff;

      span {
        text-decoration: underline;
      }
    }
  }

  .right {
    width: 171px;
    height: 185px;
    position: absolute;
    top: 110px;
    z-index: 999;
    right: 1px;
  }
}
.nodata {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
</style>
